<template>
    <div class="form-pack form-pack--summary">
        <div v-if="!isMobile">
            <h3>[{{prospect.firstname}}*]</h3>
            <p><strong>Merci d'avoir rempli le formulaire. </strong></p>
            <p>Finalisez votre inscription pour profiter de : </p>
            <ul class="pack-list">
                <li>- Votre cadeau de bienvenue</li>
                <li>- Des magazines Testachats</li>
                <li>- Nos comparateurs</li>
                <li>- Accès illimités aux articles</li>
                <li>- Jusqu’a 2.000 € d’économies par an</li>
            </ul>
            <p><strong>et plein d'autres avantages !</strong></p>
        </div>
        <div class="info-summary">
            <p><span class="label">Nom</span><span>{{prospect.lastname}}</span></p>
            <p><span class="label">Prénom</span><span>{{prospect.firstname}}</span></p>
            <p><span class="label">Genre</span><span>{{prospect.gender == 'f' ? 'Femme' : 'Homme'}}</span></p>
            <p><span class="label">Adresse</span><span>{{prospect.street}}</span></p>
            <p><span class="label">Email</span><span class="prospect-email">{{prospect.email}}</span></p>
            <p><span class="label">Téléphone</span><span>{{prospect.phone}}</span></p>

            <button @click.prevent="goTo('phone')">Modifier vos informations</button>
        </div>

    </div>
</template>

<script>
import image_mixin from "./mixins/image_mixin";
import mixin from "../../../components/form/steps/travel_step_mixin";
import {sync} from "vuex-pathify";
export default {
    computed:{
        prospect: sync('form_data'),
        isMobile() {
            return window.innerWidth <= 768;
        }
    },
    mixins:[
        image_mixin , mixin
    ],
}
</script>
